/**
 * Copyright © 2025 Delicious AI, LLC
 *
 */

import { gql } from '@apollo/client'

import { LOCATION_FRAGMENT } from '@/graphql'

export const GET_ACTION_GENERATOR_STORES = gql`
  query GetActionGeneratorStores($id: ID!, $storeFilters: StoreFilter) {
    actionGenerator(id: $id) {
      id
      title
      dueDateTime
      isSystemAction
      stores(filters: $storeFilters) {
        id
        location {
          ...Location
        }
      }
    }
  }
  ${LOCATION_FRAGMENT}
`
